import { Container, ContainerSpan, GraphContainer, Icon, InfoEnd, InfoStart, Item, ListContainer, NumberBar, SubTitle, Title } from "./StatsDash.styled";
import Coin_Icon from '@assets/svg/n_coin.svg';
import Gift_Icon from '@assets/svg/gift.svg';
import { useI18n } from '@i18n/useI18n';
import { useEffect, useRef, useState } from "react";
import { useStore } from "@store/appStore";
import db from "@utils/db";
import Tooltip from "@components/Tooltips/Tooltip";
import moment from "moment";
import RainbowLoader from "@components/Loaders/RainbowLoader";
import CountBar from "./CountBar";
import { RewardName } from "./CountBar/CountBar.styled";
import Rewards from '@models/Rewards';


interface IProps{
    
}

const StatsDash = (props:IProps) =>{
    const i18n = useI18n();
    const { systemSettings, setAdminSelection, setAdminSelectedStudent } = useStore();
    const [activityLog, setActivityLog] = useState([])
    const [rewardLog, setRewardLog] = useState([])
    const [rewardList, setRewardList] = useState([])
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        getData()
    }, [])

    let language = systemSettings.find((s) => s.APP_Setting_ID === 16);
    let localTimeZone = systemSettings.find((s) => s.APP_Setting_ID === 7);

    const getData = async () => {
        let tempReward = await db.GetRewards(language.value);
        setRewardList(tempReward);
        

        let ac_log = await db.GetTransactionLog_CoinsAllStudents(1, 50)
        setActivityLog(ac_log)

        let re_log = await db.GetRedeemRewards_Log(localTimeZone.value, language.value);
        let sortedRewards = GetTop5Rewards(re_log)

        setRewardLog(sortedRewards);
        setLoading(false)
    };

    function GetTop5Rewards(rewards) {
        
        return Object.values(
            rewards.reduce((acc, reward) => {
                if (!acc[reward.reward_id]) {
                    acc[reward.reward_id] = {
                        reward_id: reward.reward_id,
                        title: reward.title,
                        description: reward.description,
                        icon: reward.icon,
                        amount: reward.amount,
                        count: 0
                    };
                }

                acc[reward.reward_id].count++;
                return acc;
            }, {})
        )
        .sort((a, b) => (b as any).count - (a as any).count)
        .slice(0, 5);
    }

    function ReturnXNumbers(max:number) {
        if (max <= 0) return [0, 0, 0, 0, 0];

        const steps = 4;
        const stepSize = max / steps;

        const result = Array.from({ length: 5 }, (_, i) =>
            i === steps ? max : Math.round(stepSize * i)
        );

        let tmp = result.map((s, index) => {
            return (<span key={"nl_" + index}><div />{s}</span>)
        })

        return tmp;
    }

    let handleClick = (s) => {
        setAdminSelection(s.studentdisplayname, s.studentusername, "STUDENT", s.student_id);
        const seperatedName = s.studentdisplayname.replace(`${s.studentusername} -`, '');
        setAdminSelectedStudent(seperatedName, '', s.studentusername);
    }

    return (loading?
        <div style={{position:"relative", paddingTop:"200px", gridColumn:"1 / span 2"}}>
            <RainbowLoader />
        </div>
        :
        <>
            <ContainerSpan>
                <Title>{i18n.t("stat-dash-1")}</Title>
                <SubTitle>{i18n.t("stat-dash-sub-1")}</SubTitle>

                <ListContainer>
                    {activityLog?.map((l, index) => {
                        let negative = l.amount > 0?false:true;
                        let reward = rewardList?.find(r => r.id === l.reward_id);
                        let Ico = Rewards[reward?.icon]?.icon;
                        console.log(reward, Ico, rewardList)

                        if (!reward) {
                          Ico = Gift_Icon
                        }

                        return (
                            <Item onClick={() => handleClick(l)} key={"redeem_log_" + index}>
                                <Icon negative={negative} rewardBg={l.reward_id !== null}>{l.reward_id !== null?<Ico />:<Coin_Icon />}</Icon>
                                <InfoStart>
                                    <span>{l.studentdisplayname}</span>
                                    <span>{l.reward_id !== null?i18n.t("redeemed") + ": " + l.text:negative?i18n.t("stat-dash-coins-2"):i18n.t("stat-dash-coins-1")}</span>
                                </InfoStart>
                                <InfoEnd negative={negative}>
                                    <span>{l.amount}</span>
                                    <span>{moment(l.timestamp).format("DD-MM-YYYY  HH:mm")}</span>
                                </InfoEnd>
                            </Item>
                        )
                    })}
                </ListContainer>
            </ContainerSpan>

            <Container>
                <Title>{i18n.t("stat-dash-2")}</Title>
                <SubTitle>{i18n.t("stat-dash-sub-2")}</SubTitle>

                <GraphContainer>
                    {rewardLog?.map((r, index) => {
                        return(
                            <CountBar key={"nb_" + index} count={r.count} title={r.title} maxCount={rewardLog[0]?.count} />
                        )
                    })}
                    <RewardName></RewardName>
                    <NumberBar>
                        {ReturnXNumbers(rewardLog[0]?.count)}
                    </NumberBar>
                </GraphContainer>
            </Container>
        </>)
}

export default StatsDash;